/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Theme, useTheme, Box, Skeleton } from '@mui/material'
import { TOP_NAVBAR_HEIGHT } from '@app/app-constants'

function RiskStoriesDetailLoading() {
  const theme = useTheme()

  return (
    <Box css={wrapper(theme)}>
      <Box css={contentArea()}>
        <Box css={sideDrawer(theme)}>
          <Skeleton variant="rectangular" height={140} animation="wave" />
          <Skeleton variant="rectangular" height={280} animation="wave" />
          <Skeleton variant="rectangular" height={140} animation="wave" />
          <Skeleton variant="rectangular" height={280} animation="wave" />
        </Box>

        <Box css={mapSkeleton(theme)}>
          <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
        </Box>
      </Box>
    </Box>
  )
}

export default RiskStoriesDetailLoading

const wrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - ${TOP_NAVBAR_HEIGHT}px);
  background-color: ${theme.palette.grey[100]};
`

const contentArea = () => css`
  display: flex;
  flex: 1;
  overflow: hidden;
`

const sideDrawer = (theme: Theme) => css`
  width: 600px;
  background-color: ${theme.palette.grey[50]};
  border-right: 1px solid ${theme.palette.divider};
  overflow-y: auto;
  padding: ${theme.spacing(3)};
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(2)};
`

const mapSkeleton = (theme: Theme) => css`
  flex: 1;
  background-color: ${theme.palette.grey[100]};
  overflow: hidden;
`
